import React from 'react';
import styled from 'styled-components';

import { fadeIn } from '../../healtheraComponents';

import { ReactComponent as RedFlagSvg } from '../../resources/red-flag.svg';

const OrderFlag = ({ hint }) => {
  return (
    <FlagContainer>
      <RedFlagSvg />
      {hint && <Hint>{hint}</Hint>}
    </FlagContainer>
  );
};

const Hint = styled.p`
  z-index: 1;
  position: absolute;
  right: calc(100% + 5px);
  top: 0;
  
  padding: 5px;
  
  min-width: 200px;
  text-align: center;
  font-size: 14px; 
  display: none;
  
  background-color: #ffc4b8;
  color: black;
  transform: translateY(-50%);
`;

const FlagContainer = styled.p`
  position: relative;
  margin: 0;

  width: 25px;
  height: 25px;

  &:hover ${Hint} {
    display: block;
    animation: 0.15s ${fadeIn} ease-in both;
  }
`;

export default OrderFlag;
